export function main() {

  if ($(window).width() >= 1250) {
    $('#fullpage').fullpage({
      menu: '.fullpage-menu',
      onLeave: function(index, nextIndex, direction){
          var leavingSection = $(this);
        }
    });
  }

  $('.lang__active').on('click', function () {
    $('.lang__box').toggleClass('active');
  });

  $(document).on('click', (e) => {
    if (!$(e.target).closest('.lang__box, .lang__active').length) {
      $('.lang__box').removeClass('active');
    }
    e.stopPropagation();
  });

  $('.header__callback-btn').on('click', function () {
    $('.callback').toggleClass('active');
  });

  $(document).on('click', (e) => {
    if (!$(e.target).closest('.callback, .header__callback-btn').length) {
      $('.callback').removeClass('active');
    }
    e.stopPropagation();
  });

  $('.basket.no-login').on('click', () => {
    $(".login__btn" ).trigger('click');
  })

  $('.login__btn').on('click', function () {
    $('.authorization').toggleClass('active');
  });

  $(document).on('click', (e) => {
    if (!$(e.target).closest('.authorization, .login__btn, .registration-back, .basket.no-login').length) {
      $('.authorization').removeClass('active');
    }
    e.stopPropagation();
  });

  $('.registration-back').on('click', function () {
    $('.registration').removeClass('active');
    $('.authorization').addClass('active');
  });

  $('.registration-btn').on('click', function () {
    $('.authorization').removeClass('active');
    $('.registration').addClass('active');
  });

  $('.forgot-btn').on('click', function () {
    $('.authorization').removeClass('active');
    $('.forgot').addClass('active');
  });

  $(document).on('click', (e) => {
    if (!$(e.target).closest('.registration, .registration-btn').length) {
      $('.registration').removeClass('active');
    }
    e.stopPropagation();
  });

  $(document).on('click', (e) => {
    if (!$(e.target).closest('.forgot, .forgot-btn').length) {
      $('.forgot').removeClass('active');
    }
    e.stopPropagation();
  });

  $('.menu-opener, .menu__close').on('click', function () {
    $('.menu').toggleClass('active');
    $('body').toggleClass('holder');
    if ($('.catalog__dropdown').hasClass('active')) {
      $('.catalog__dropdown').removeClass('active');
      $('body').addClass('holder');
    }
  });

  $(document).on('click', (e) => {
    if (!$(e.target).closest('.menu, .menu-opener, .header').length) {
      $('.menu').removeClass('active');
      $('body').removeClass('holder');
    }
    e.stopPropagation();
  });

  function openCloseCatalog() {
    $('.catalog-opener__btn').on('click', ()=> {
      $('.catalog__dropdown').toggleClass('active');
      $('body').toggleClass('holder');
      if ($('.menu').hasClass('active')) {
        $('.menu').removeClass('active');
        $('body').addClass('holder');
      }
    });
  }
  openCloseCatalog()


  if ($(window).width() < 768) {
    const catalogHtml = $('.catalog-opener').html();
    // $('.mobile-catalog').html(catalogHtml);
    // openCloseCatalog()
    $('.menu nav ul li').each(function() {
      const newText = $(this).data('menu');
      $(this).find('a').text(newText)
    })
  }

  $(document).on('click', (e) => {
    if (!$(e.target).closest('.catalog__dropdown, .catalog-opener__btn').length) {
      $('.catalog__dropdown').removeClass('active');
      $('body').removeClass('holder');
    }
    e.stopPropagation();
  });

  if ($(window).width() >= 1024) {
    $('.catalog__list li > a').on('mouseenter', function() {
      $('.sub-list').hide();
    })
    $('.catalog__list a').on('mouseenter', function() {
      const cat = $(this).data('category');
      const grid = $(this).data('grid');
      $('.sub-list').hide();
      $('.catalog-grid').removeClass('active');
      $('.catalog__col').find(`.sub-list-${cat}`).fadeIn();
      $('.scrollable').mCustomScrollbar({
        advanced:{
          updateOnContentResize: true
        }
      });
    })
    $('.catalog__dropdown').on('mouseleave', function() {
      $('.sub-list').fadeOut();
    })
    $('.sub-list').on('mouseover', function() {
      $(this).show();
    });
    $('.catalog__dropdown li a').on('mouseover', function() {
      let bg = $(this).data('img');
      // $('.catalog-image').attr('style', 'background-image:url('+ bg +')');
      $('.catalog-image').attr('style', `background-image:url("${bg}")`);
    });
  }


  const ua = navigator.userAgent;
  const iOS = /iPad|iPhone|iPod/.test(ua);
  const iOS11 = /OS 9_1|OS 11_0_1|OS 11_0_2|OS 11_0_3|OS 11_1|OS 11_1_1|OS 11_1_2|OS 11_2|OS 11_2_1/.test(ua);
  if (iOS && iOS11) {
    $('.product__financial, .product__apply, .callback-btn, .spare-information__callback-btn, .parts__callback-btn').on('click', () => {
      $('body').addClass('iosBugFixCaret');
    });
  }

  // $('.product__financial').on('click', function () {
  //   $('.popup-cost').toggle();
  //   $('.select .select__list').mCustomScrollbar();
  // });

  $('.product__apply').on('click', function () {
    $('.popup-cost-product').toggle();
    $('.select .select__list').mCustomScrollbar();
  });

  $('.spare-information__callback-btn, .callback-btn').on('click', function () {
    $('.popup-callback').toggle();
    $('.select .select__list').mCustomScrollbar();
  });

  $('.parts__callback-btn').on('click', function () {
    $('.popup-callback-parts').toggle();
    $('.select .select__list').mCustomScrollbar();
  });

  $('.area-info__password-btn').on('click', function (e) {
    e.preventDefault();
    $('.popup-password-change').toggle();
  });

  // $('.create-application__sidebar-form .submit-btn').on('click', function (e) {
  //   e.preventDefault();
  //   $('.popup-data-changed').toggle();
  // });

  $('.callback-mobile').on('click', function (e) {
    e.preventDefault();
    $('.popup-callback-mobile').toggle();
  });

  $('.area-info__password-title span').on('click', function() {
    $('.popup-password__info').toggleClass('active');
  })

  $(document).on('click', (e) => {
    if (!$(e.target).closest('.popup-password__info, .area-info__password-title span').length) {
      $('.popup-password__info').removeClass('active');
    }
    e.stopPropagation();
  });

  $('.popup__overlay, .popup__close').on('click', function () {
    $('.popup').css('display', 'none');
    $("body").removeClass('iosBugFixCaret');
  });

  // $('<div class="quantity-button quantity-up"><svg><use xlink:href="/front/dist/images/sprite.svg#plus"/></svg></div><div class="quantity-button quantity-down"><svg><use xlink:href="/images/sprite.svg#minus"/></svg></div>').insertAfter('.quantity input');
    $('.quantity').not('.popup-cart-key').each(function() {
      var spinner = jQuery(this),
        input = spinner.find('input[type="number"]'),
        btnUp = spinner.find('.quantity-up'),
        btnDown = spinner.find('.quantity-down'),
        min = input.attr('min'),
        max = input.attr('max');

      btnUp.click(function() {
        var oldValue = parseFloat(input.val());
        if (oldValue >= max) {
          var newVal = oldValue;
        } else {
          var newVal = oldValue + 1;
        }
        spinner.find("input").val(newVal);
        spinner.find("input").trigger("change");
      });

      btnDown.click(function() {
        var oldValue = parseFloat(input.val());
        if (oldValue <= min) {
          var newVal = oldValue;
        } else {
          var newVal = oldValue - 1;
        }
        spinner.find("input").val(newVal);
        spinner.find("input").trigger("change");
      });

    });


    // $('.popup-lizing__text').mCustomScrollbar({
    //   advanced:{
    //     updateOnContentResize: true
    //   }
    // });

    // $('.lizing-list__box').each(function(index, element) {
    //     $(element).on('click', function(e) {
    //         e.preventDefault();
    //         $("#logo").html($(element).find('.lizing-list__logo').html());
    //         $("#text .mCSB_container").html($(element).find('.lizing-list__text').html());
    //         $("#title").html($(element).find('.lizing-list__title').html());
    //         $('.popup-lizing').addClass('active');
    //         $('.popup-lizing__text').mCustomScrollbar({
    //           advanced:{
    //             updateOnContentResize: true
    //           }
    //         });
    //     })
    // });

    $('.popup-lizing__overlay, .popup-lizing__close').on('click', function () {
      $('.popup-lizing').removeClass('active');
    });

  if ($(window).width() < 1250) {
    $(".header__contacts").appendTo(".navigation");
  }
  if ($(window).width() >= 1250) {
    $(".header__contacts").appendTo(".header__box");
  }
  $(window).resize(function () {
    if ($(window).width() < 1250) {
      $(".header__contacts").appendTo(".navigation");
    }
    else {
      $(".header__contacts").appendTo(".header__box");
    }
  });

  if ($(window).width() <= 1023) {
    $('.catalog__list a.has-child').on('click', function(e) {
      const catLink = $(this).parent().html().replace(/\s+/g,' ');
      e.preventDefault()
      const cat = $(this).data('category');
      const grid = $(this).data('grid');
      $('.catalog__first-level').hide();
      $('.sub-list').hide();
      $('.catalog-grid').removeClass('active');
      const SubList = $('.catalog__col').find(`.sub-list-${cat}`).fadeIn();
      $('.main-cat').parent().remove();
      const catLinkInSubList = SubList.prepend(`<li>${catLink}</li>`);
      const catLinkInSubListLink = catLinkInSubList.find('a.has-child');
      catLinkInSubListLink.removeClass('has-child').addClass('main-cat');
    })

    $('.back-btn').on('click', function(e) {
      e.preventDefault();
      $('.sub-list').hide();
      $('.catalog__first-level').show();
    })
  }

  if ($(window).width() <= 1249) {
    $('.navigation__list a').on('click', function (e) {
      e.preventDefault();
      var idBlock = $(this).attr('href').replace('#','');
      var idTop = $(`[data-anchor="${idBlock}"]`).offset().top - 62;
      $('html, body').stop().animate({
        scrollTop: idTop
      }, 1000);
    });
  }

  $('.password svg').on('click', function (e) {
    $('.password__popup').removeClass('active');
    $(this).next('.password__popup').toggleClass('active');
  });
  $(document).on('click', (e) => {
    if (!$(e.target).closest('.password svg, .password__popup').length) {
      $('.password__popup').removeClass('active');
    }
    e.stopPropagation();
  });

  $('.time svg').on('mouseover', function (e) {
    $(this).next('.time__popup').addClass('active');
  });
  $('.time svg, .time__popup').on('mouseleave', function (e) {
    $('.time__popup').removeClass('active');
  });

  $('.delete svg').on('mouseover', function (e) {
    $(this).next('.delete__popup').addClass('active');
  });
  $('.delete svg, .delete__popup').on('mouseleave', function (e) {
    $('.delete__popup').removeClass('active');
  });

  $('.settings svg').on('mouseover', function (e) {
    $(this).next('.settings__popup').addClass('active');
  });
  $('.settings svg, .settings__popup').on('mouseleave', function (e) {
    $('.settings__popup').removeClass('active');
  });

  $('.navigation__list a').on('click', function (e) {
    $('.navigation, .menu-opener').removeClass('active');
    $('.navigation-overlay').toggle();
  });

  $('.menu-opener').on('click', function () {
    $(this).toggleClass('active');
    $('.navigation').toggleClass('active');
    $('.navigation-overlay').toggle();
  });

  $('.navigation-overlay').on('click', function () {
    $(this).toggle();
    $('.navigation').toggleClass('active');
    $('.menu-opener').toggleClass('active');
  });

  $('.close, .overlay').on('click', function () {
    $('.popup').css('display', 'none');
  });

  $('.popup-thanks__close, .popup-thanks__overlay').on('click', function () {
    $('.popup-thanks').css('display', 'none');
  });

  const open = $('.spare-products__text').data('open');
  const close = $('.spare-products__text').data('close');

  $('.spare-products__text').readmore({
    speed: 75,
    moreLink: `<a class="open-read" href="#">${open}</a>`,
    lessLink: `<a class="open-read close-read" href="#">${close}</a>`
  });

  $('.application__sidebar-value').readmore({
    speed: 75,
    moreLink: `<a class="open-read__value" href="#"><svg xmlns="http://www.w3.org/2000/svg" width="37.062" height="21.063" viewBox="0 0 37.062 21.063"><path d="M944.374,868l16.615,16.277,15.637-15.32" transform="translate(-941.969 -867)"/></svg></a>`,
    lessLink: `<a class="open-read__value close-read" href="#"><svg xmlns="http://www.w3.org/2000/svg" width="37.062" height="21.063" viewBox="0 0 37.062 21.063"><path d="M944.374,868l16.615,16.277,15.637-15.32" transform="translate(-941.969 -867)"/></svg></a>`
  });

  function flyToElement(flyer, flyingTo) {
    const $func = $(this);
    const divider = 3;
    const flyerClone = $(flyer).clone();
    $(flyerClone).css({
      position: 'absolute',
      top: `${$(flyer).offset().top}px`,
      left: `${$(flyer).offset().left}px`,
      opacity: 1,
      'z-index': 1000
    });
    $('body').append($(flyerClone));
    const gotoX = $(flyingTo).offset().left + ($(flyingTo).width() / 2) - ($(flyer).width() / divider) / 2;
    const gotoY = $(flyingTo).offset().top + ($(flyingTo).height() / 2) - ($(flyer).height() / divider) / 2;
    $(flyerClone).animate({
      opacity: 0.4,
      left: gotoX,
      top: gotoY,
      width: $(flyer).width() / divider,
      height: $(flyer).height() / divider
    }, 700,
    () => {
      $(flyingTo).fadeOut('fast', () => {
        $(flyingTo).fadeIn('fast', function() {
          $(flyerClone).fadeOut('fast', function() {
            $(flyerClone).remove();
          });
        });
      });
    });
  }

  $('.spare-products__btn').on('click', function (e) {
    e.preventDefault();
    const itemImg = $(this).parent().prev().find('.spare-products__image');
    flyToElement($(itemImg), $('.header__block .basket'));
  });

  if ($(window).width() >= 768) {
    $(window).scroll(function () {
      if ($(this).scrollTop() >= 300) {
        $('.btn-up').addClass('show');
      } else {
        $('.btn-up').removeClass('show');
      }
    });
    $('.btn-up').on('click', (event) => {
      event.preventDefault();
      $('body,html').animate({ scrollTop:0 }, 800);
    });
  }

  $('.table-cell__info').on('click', function(e) {
    e.preventDefault();
    $('.table-cell__info-popup').removeClass('open');
    $(this).find('.table-cell__info-popup').toggleClass('open');
  });
  $(document).on('click', (e) => {
    if (!$(e.target).closest('.table-cell__info, .table-cell__info-popup').length) {
      $('.table-cell__info-popup').removeClass('open');
    }
    e.stopPropagation();
  });


  $('.tab-options__item.has_description').each(function () {
    $(this).on('click', function () {
      if ($(this).find('.option__description').length > 0) {
        const text = $(this).find('.option__description').html();
        $('.popup-options-text').html('');
        $('.popup-options-text').html(text);
        $('.popup-options-item').fadeIn();
        $('.popup-options-text').scrollTop(0);
      }
    })
  })

  // $('.popup-options-item .popup__close, .popup-options-item .popup__overlay').on('click', function() {
  //   $('.popup-options-item').fadeOut();
  //   $('.popup-options-text .mCSB_container').html('');
  // })

  $('.header-aplication.not-login .header-aplication__box').on('click', function(e) {
    e.preventDefault();
    $(this).siblings('.header-aplication__popup').toggleClass('open');
  })

  $(document).on('click', (e) => {
    if (!$(e.target).closest('.header-aplication.not-login .header-aplication__box, .header-aplication__popup').length) {
      $('.header-aplication__popup').removeClass('open');
    }
    e.stopPropagation();
  });


  $(document).on('click', (e) => {
    if (!$(e.target).closest('.basket.no-login .basket__btn, .basket__info').length) {
      $('.basket__info').removeClass('open');
    }
    e.stopPropagation();
  });


  $('.spare-products__availability').on('click', function closeOpenInfo() {
    $(this).parents('.spare-products__box').toggleClass('active')
    $(this).parents('.spare-products__box').find('.spare-products__table').slideToggle()
  })

  $('.basket-block__availability').on('click', function closeOpenInfo() {
    $(this).parents('.basket-block__item').find('.spare-products__table').slideToggle()
  })


}



// WEBPACK FOOTER //
// app/scripts/components/main.js